import React from 'react';
import * as _ from 'lodash';
import { connect } from 'formik';


export default connect(
  class FormikAutoSave extends React.Component {
    state = {
      isSaving: false
    };

        componentDidUpdate(prevProps) {

        if (this.props.disabled) return;
        if (this.props.formik &&
        prevProps.formik &&
        !_.isEqual(prevProps.formik.values, this.props.formik.values)
      ) {
        // const diff = difference(prevProps.formik.values, this.props.formik.values);
        // console.log('diff', diff);
        this.save();
      }
    }

    save = _.debounce(() => {
      const { formik } = this.props;
      if (this.props.validateBeforeSave === true && !formik.isValid) {
        return;
      }

      this.doSave();
      // try {
      //   formik.validationSchema = formik.validationSchema
      //     ? formik.validationSchema
      //     : this.props.formContext.yupSchema;
      //   let context = this.props.formContext.getValidationContext(
      //     this.props.formik.values
      //   );

      //   if (formik.validationSchema) {
      //     const validationSchema =
      //       typeof formik.validationSchema === 'object'
      //         ? formik.validationSchema
      //         : formik.validationSchema();
      //     validationSchema
      //       .validate(formik.values, { abortEarly: false, context })
      //       .then(() => {
      //         this.doSave();
      //       })
      //       .catch(error => {
      //         const foundErrors = error.inner.filter(x => x.value); //errors of fields with values only (skipping required and min on zero length)
      //         const isValid = foundErrors.length === 0;

      //         if (isValid) this.doSave();
      //       });
      //   } else {
      //     console.error('No validation schema!');
      //   }
      // } catch (error) {
      //   console.log('Auto Save failed', error);
      // }
    }, this.props.debounce);

    doSave() {
      this.setState({ isSaving: true, saveError: null }, () => {
        Promise.resolve(this.props.onSave(this.props.formik.values)).then(
          () => this.setState({ isSaving: false, lastSaved: new Date() }),
          saveError => this.setState({ isSaving: false, saveError })
        );
      });
    }

    render() {
      return this.props.render ? this.props.render(this.state) : null;
    }
  }
);
